export default "__VITE_ASSET__C4LFF8az__"